import React from 'react';
import { RadioGroupContext } from './radio-group-context';
import { useUniqID } from '../hooks';
/**
 * `<RadioGroup>` - обёртка для нескольких Радио-Кнопок.
 * @example ```tsx
 <RadioGroup value={value} onChange={handleChange} name="response">
  <Radio label="Yes" value="Yes" />
  <Radio label="No" value="No" />
 </RadioGroup>
 * ```
 */
export const RadioGroup = ({
  children,
  onChange,
  value,
  name: nameProp
}) => {
  const defaultName = useUniqID();
  const name = nameProp != null ? nameProp : defaultName;
  return /*#__PURE__*/React.createElement(RadioGroupContext.Provider, {
    value: {
      name,
      value,
      onChange
    }
  }, children);
};